import React, { useImperativeHandle, useState, useRef } from 'react';
import { CustomerResourceSortDialog } from '@Local/CustomerResource/Dialog/';
import useForkRef from '@Util/hook/useForkRef';

const CustomerResourceDialogBox = React.forwardRef((props, ref) => {
    const dialogRef = useRef(null);
    const combinedRef = useForkRef(ref, dialogRef);
    const [openDialog, setOpenDialog] = useState('');
    const [sourceData, setSourceData] = useState({});
    const refreshRef = useRef(null);

    const doRefresh = () => {
        if (refreshRef.current && typeof refreshRef.current === 'function') {
            refreshRef.current();
        }
    };

    useImperativeHandle(
        combinedRef,
        () => {
            return {
                openCustomerResourceSortDialog: (sourceData, _refreshFn = () => {}) => {
                    setSourceData(sourceData);
                    setOpenDialog('customerResourceSort');
                    refreshRef.current = _refreshFn;
                },
                closeDialog: () => handleCloseDialog(),
            };
        },
        // eslint-disable-next-line
        [],
    );

    const handleCloseDialog = () => {
        setOpenDialog(null);
        setSourceData(null);
        refreshRef.current = null;
    };

    return (
        <React.Fragment>
            <CustomerResourceSortDialog 
                open={openDialog === 'customerResourceSort'} 
                onClose={handleCloseDialog} 
                refresh={doRefresh} 
                sourceData={sourceData}
            />
        </React.Fragment>
    );
});

export default CustomerResourceDialogBox;
